import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { get as _get } from "lodash";

import { fetchNews } from "../../../redux/services/campaign";
import { ShowContentLoader, showAlertMessage } from "../../../resusableComponents/common/formElements";

import IconHistory from "../../../assets/icons/icon-history.svg";
import IconSubsidairies from "../../../assets/icons/icon-subsidairies.svg";
import IconEconomic from "../../../assets/icons/icon-economic.svg";
import IconRelatedNews from "../../../assets/icons/icon-related-news.svg";
import IconLink from "../../../assets/icons/icon-link.svg";
import IconTime from "../../../assets/icons/icon-time.svg";
import IconDocument from "../../../assets/icons/icon-document.svg";
//import IconMouse from "../../../assets/icons/icon-mouse.svg";
//import IconMonitor from "../../../assets/icons/icon-monitor.svg";

let cachedNews = null;

class Overview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      relatedNews: [],
      isNewsLoading: false,
      activeMicroMacroTab: "",
    };
  }

  componentDidMount() {
    this._initializeNews();
  }

  componentDidUpdate(prevProps) {
    const prevNews = _get(prevProps.companyCardDetail, "news", []);
    const currentNews = _get(this.props.companyCardDetail, "news", []);

    if ((prevNews || []).length === 0 && (currentNews || []).length > 0 && cachedNews === null) {
      cachedNews = currentNews;
      this.setState({ relatedNews: currentNews });
    }
  }

  _initializeNews = () => {
    const { companyCardDetail } = this.props;
    const initialNews = _get(companyCardDetail, "news", []);

    if (cachedNews === null && initialNews && (initialNews || []).length > 0) {
      cachedNews = initialNews;
      this.setState({ relatedNews: initialNews });
    } else {
      this._fetchRelatedNews();
    }
  };

  _fetchRelatedNews = async (forceRefresh = false) => {
    const { companyCardDetail, clientId, campaignId } = this.props;
    const domain = _get(companyCardDetail, "domain", "");
    if (!domain) return;

    if (!forceRefresh && cachedNews !== null) {
      this.setState({ relatedNews: (cachedNews || []) });
      return;
    }

    this.setState({ isNewsLoading: true });
    try {
      const response = await fetchNews({
        company_id: _get(companyCardDetail, "company_id", ""),
        client_id: (clientId || 0),
        campaign_id: (campaignId || 0),
        company_name: _get(companyCardDetail, "company", ""),
        domain: domain,
        is_refresh_news: true
      });
      if ((response.flag || false) === true) {
        const newsData = _get(response, "data", []);
        cachedNews = (newsData || []);

        if ((cachedNews || []).length > 0) {
          this.setState({ relatedNews: (cachedNews || []) });
        }
      }
    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while fetching company card detail."));
    } finally {
      this.setState({ isNewsLoading: false });
    }
  };

  _renderEconomicContext = () => {
    const { companyCardDetail } = this.props;
    const { activeMicroMacroTab } = this.state;

    const microMacroContent = _get(companyCardDetail, "micro_macro_content", []);

    if ((microMacroContent || []).length === 0) {
      return (
        <div className="card bg-secondary-de border border-secondary rounded-4 shadow-none">
          <div className="card-body p-4">
            <p className="text-uppercase text-secondary fw-bold mb-2 d-flex align-items-center gap-1">
              <img src={IconEconomic} alt="Economic Icon" />
              <FormattedMessage id="company_card.overview.economic_context" defaultMessage="Economic Context" />
            </p>
            <span className="text-grey-93 heading-05 fw-semibold"><FormattedMessage id="label.no_data_found" defaultMessage="No data found." /></span>
          </div>
        </div>
      );
    }

    const activeTopicKey = activeMicroMacroTab || _get(microMacroContent, "[0].topic", "");
    const activeTopic = (microMacroContent || []).find((item) => _get(item, "topic", "") === activeTopicKey) || microMacroContent[0];

    return (
      <div className="card border border-secondary rounded-4 shadow-none">
        <div className="card-body p-4">
          <p className="text-uppercase text-secondary fw-bold mb-2 d-flex align-items-center gap-1">
            <img src={IconEconomic} alt="Economic Icon" />
            <FormattedMessage id="company_card.overview.economic_context" defaultMessage="Economic Context" />
          </p>

          {/* Dynamic topic tabs */}
          <ul className="nav nav-tabs mb-4" role="tablist">
            {(microMacroContent || []).map((item, idx) => {
              const topic = _get(item, "topic", "");
              const isActive = topic === activeTopicKey;
              return (
                <li className="nav-item" key={idx}>
                  <button
                    className={`nav-link text-capitalize p-2 ${isActive ? "active" : ""}`}
                    onClick={() => this.setState({ activeMicroMacroTab: topic })}
                    type="button"
                  >
                    {topic}
                  </button>
                </li>
              );
            })}
          </ul>

          <div className="tab-content">
            <div className="tab-pane fade show active">
              <div className="d-flex flex-column gap-3">
                <div>
                  <p className="text-grey-93 fw-semibold mb-1">
                    <FormattedMessage id="company_card.overview.macro_economic" defaultMessage="Macro-Economic" />
                  </p>
                  <p className="fw-bold text-dark heading-04">{_get(activeTopic, "data.macro", "")}</p>
                </div>
                <hr className="border-secondary opacity-25" />
                <div>
                  <p className="text-grey-93 fw-semibold mb-1">
                    <FormattedMessage id="company_card.overview.micro_economic" defaultMessage="Micro-Economic (Sector Level)" />
                  </p>
                  <p className="fw-bold text-dark heading-04">{_get(activeTopic, "data.micro", "")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { intl, companyCardDetail } = this.props;

    return (
      <div className="tab-pane fade show active">
        <div className="row gy-4 mt-0">

          {/* Left column */}
          <div className="col-lg-6">
            <h3 className="heading-05 text-uppercase fw-bold text-grey-93 mb-4">
              <FormattedMessage id="company_card.overview.general_overview" defaultMessage="General Overview" />
            </h3>
            <p className="text-dark heading-04 fst-italic mb-4">"{_get(companyCardDetail, "description", "")}"</p>

            <div className="row gy-3 mb-4">
              <div className="col-lg-6">
                <div className="card bg-grey-fa rounded-4 border border-grey-e6 shadow-none">
                  <div className="card-body p-4">
                    <p className="text-uppercase fw-bold text-grey-93 mb-2 d-flex gap-1 align-items-center">
                      <img src={IconHistory} alt="History Icon" />
                      <FormattedMessage id="company_card.overview.history" defaultMessage="History" />
                    </p>
                    <p className="fw-bold text-dark heading-04">
                      {_get(companyCardDetail, "founded", "")
                        ? String(_get(companyCardDetail, "founded", "")).includes("Founded")
                          ? _get(companyCardDetail, "founded", "")
                          : `Founded ${_get(companyCardDetail, "founded", "")}`
                        : ""}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="card bg-grey-fa rounded-4 border border-grey-e6 shadow-none">
                  <div className="card-body p-4">
                    <p className="text-uppercase fw-bold text-grey-93 mb-2 d-flex gap-1 align-items-center">
                      <img src={IconSubsidairies} alt="Subsidiaries Icon" />
                      <FormattedMessage id="company_card.overview.key_subsidiaries" defaultMessage="Key Subsidiaries" />
                    </p>
                    <p
                      className="fw-bold text-dark heading-04 mb-0"
                      style={{
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden"
                      }}
                      title={
                        _get(companyCardDetail, "subsidiaries") || [].length > 0
                          ? `${(_get(companyCardDetail, "subsidiaries") || []).length} Entities (${(_get(companyCardDetail, "subsidiaries") || []).join(", ")})`
                          : `${(_get(companyCardDetail, "subsidiaries") || []).length} Entities`
                      }
                    >
                      {(_get(companyCardDetail, "subsidiaries") || []).length} Entities
                      {(_get(companyCardDetail, "subsidiaries") || []).length > 0 && (
                        <span className="fw-normal"> ({(_get(companyCardDetail, "subsidiaries") || []).join(", ")})</span>
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Economic context */}
            {this._renderEconomicContext()}
          </div>

          {/* Right column */}
          <div className="col-lg-6">
            <div className="row gy-3 mb-4">
              <div className="col-lg-6">
                <p className="text-uppercase fw-bold text-grey-93 mb-2">
                  <FormattedMessage id="company_card.overview.company_size" defaultMessage="Company Size" />
                </p>
                <p className="fw-bold text-dark heading-04">{_get(companyCardDetail, "company_size", "")}</p>
              </div>
              <div className="col-lg-6">
                <p className="text-uppercase fw-bold text-grey-93 mb-2">
                  <FormattedMessage id="company_card.overview.annual_revenue" defaultMessage="Annual Revenue" />
                </p>
                <p className="fw-bold text-dark heading-04">{_get(companyCardDetail, "annual_revenue", "")}</p>
              </div>
              <div className="col-lg-12 mt-6">
                <p className="text-uppercase fw-bold text-grey-93 mb-2">
                  <FormattedMessage id="company_card.overview.major_project_portfolio" defaultMessage="Major Project Portfolio" />
                </p>
                <div className="d-flex flex-wrap gap-2">
                  {(_get(companyCardDetail, "major_projects") || []).length > 0 ? (
                    (_get(companyCardDetail, "major_projects") || []).map((p, i) => (
                      <span key={i} className="bg-white text-dark border heading-05 fw-semibold rounded-3 px-3 py-2">
                        {p}
                        {(_get(p, "status", "")) && <span className="text-grey-8e fw-medium">({_get(p, "status", "")})</span>}
                      </span>
                    ))
                  ) : (
                    <span className="text-grey-93 heading-05 fw-semibold"><FormattedMessage id="label.no_data_found" defaultMessage="No data found." /></span>
                  )}
                </div>
              </div>
            </div>

            {/* Related news */}
            <div className="card shadow-none rounded-4 border border-grey-e6">
              <div className="card-body p-4">
                <h3 className="heading-05 text-uppercase fw-bold mb-3 d-flex gap-1 align-items-center text-grey-93 justify-content-between">
                  <div className="d-flex gap-2">
                    <img src={IconRelatedNews} alt="Related News Icon" />
                    <FormattedMessage id="company_card.overview.related_news" defaultMessage="Related News & Case Studies" />
                  </div>
                  <div>
                    <button
                      className="btn btn-outline-primary waves-effect btn-sm"
                      onClick={() => this._fetchRelatedNews(true)}
                      disabled={this.state.isNewsLoading}
                    >
                      <FormattedMessage id="company_card.overview.refresh" defaultMessage="Refresh" />
                    </button>
                  </div>
                </h3>
                <div className="d-flex flex-column gap-2">
                  {this.state.isNewsLoading ? (
                    <div className="text-center p-3 pt-20">
                      <ShowContentLoader />
                    </div>
                  ) : (_get(this.state, "relatedNews") || []).length > 0 ? (
                    (_get(this.state, "relatedNews") || []).map((n, i) => (
                      <div key={i} className="d-flex justify-content-between align-items-center p-3 bg-grey-fa rounded-3 border border-grey-e6">
                        <div>
                          <span className="fw-bold text-dark">{_get(n, "headline", "")}</span>
                          {_get(n, "published_date", "") && (
                            <p className="text-grey-93 heading-05 mb-0">{_get(n, "published_date", "")}</p>
                          )}
                        </div>
                        {(_get(n, "source_url", "") !== "") && (
                          <a href={_get(n, "source_url", "")} target="_blank" rel="noopener noreferrer">
                            <img src={IconLink} alt="Link Icon" />
                          </a>
                        )}
                      </div>
                    ))
                  ) : (
                    <span className="text-grey-93 heading-05 fw-semibold"><FormattedMessage id="label.no_data_found" defaultMessage="No data found." /></span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Engagement History Timeline */}
        <hr className="my-8 border-grey-93" />

        <div className="row mt-5">
          <div className="col-lg-12">
            <h3 className="heading-04 fw-bold text-dark mb-4 d-flex align-items-center gap-1">
              <img src={IconTime} alt="Time Icon" width={18} />
              <FormattedMessage id="company_card.overview.engagement_history" defaultMessage="Engagement History" />
            </h3>

            <div>
              <div className="d-flex flex-column">
                {(_get(companyCardDetail, "engagementHistory") || []).length > 0 ? (
                  (_get(companyCardDetail, "engagementHistory") || []).map((event, i) => (
                    <div key={i} className="d-flex gap-8">
                      <div className="engagement-timeline">
                        <div className={`engagement-timeline-icon ${_get(event, "type", "") === "Content" ? "border-secondary" : _get(event, "theme", "") === "warning" ? "border-warning" : "border-primary"}`}>
                          <img src={IconDocument} alt="Time Icon" />
                        </div>
                      </div>

                      <div key={i} className="card shadow-none rounded-4 border border-grey-e6 w-100 mb-4">
                        <div className="card-body p-6">
                          <div className="d-flex justify-content-between align-items-start mb-2">
                            <span className="text-grey-93 fw-semibold heading-05">{_get(event, "date", "")}</span>
                            <span className={`badge ${_get(event, "type", "") === "Content" ? "bg-primary-66 text-primary " : _get(event, "type", "") === "Website" ? "bg-warning-fc text-dark" : "bg-danger-df text-danger"} text-uppercase`}>
                              {_get(event, "type", "")}
                            </span>
                          </div>
                          <h4 className="heading-03 fw-bold text-dark mb-1 text-capitalize">{_get(event, "asset", "")}</h4>
                          <p className="text-grey-93 mb-2 text-capitalize">
                            {intl.formatMessage({ id: "company_card.contacts.recent_engagement", defaultMessage: "Recent Engagement" })}: <strong>{`${_get(event, "triggered_by", "")} (${_get(event, "job_title", "")})`}</strong>
                          </p>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="d-flex justify-content-center align-items-center p-3 bg-grey-fa rounded-3 border" style={{ minHeight: 120, borderStyle: "dashed" }}>
                    <div className="text-center">
                      <p className="text-grey-93 heading-05 fw-semibold mt-2 mb-0">
                        <FormattedMessage id="label.no_data_found" defaultMessage="No data found." />
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(Overview);
